import { AjaxPost } from "../Services/index";
import { CartItem } from "./index";
import { ICartData } from "./types/ICartData";
import { IPromoResponseModel } from "./types/IPromoResponseModel";
import { ICartRowItem } from "./types/ICartRowItem";
import { Slugify, ParseDate } from "../Helpers/index";

export class CartHeaders {
    
    //ViewComponents
    private CartSummary: KnockoutComputed<string> = ko.pureComputed(() => {
        let self = this;
        if (self.NumOfItems() > 0)
          if (self.SubTotal() != null && self.NumOfItems() != null)
            return '$' + self.SubTotal().toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 });
        return "Cart Empty";
    });

    private TitleString: KnockoutComputed<string> = ko.pureComputed(() => {
        let self = this;
        return "Order #:" + self.LocalKey();
    })

    private CartPreviewImgCSS = (fieldData) => {
        return ko.computed({
            owner: this,
            read: () => {
                if (!fieldData) {
                    return "d-none";
                } else {
                    return "my-auto";
                }
            }
        }, this);
    }

    private RemainderCount: KnockoutComputed<string> = ko.pureComputed(() => {
        let self = this;
        let remainder = self.CartItems().length - self.CartItemsLimited().length;
        let countable = remainder > 1 ? 'items' : 'item';

        return remainder + ' more ' + countable + ' in the cart';
    })

    private CartItemsLimited: KnockoutComputed<Array<CartItem>> = ko.pureComputed(() => {
        let self = this;

        return self.CartItems().slice(0, 10);

    })

    public SavedCarts = ko.observableArray([]);
    public SavedCartsSummary = ko.pureComputed(() => {
        // Update front-end status panel and alert labels
        if (this.SavedCarts().length > 0) {
            return 'View Saved Carts (' + this.SavedCarts().length + ')';
        }
        if (this.SavedCarts().length === 0) {
            return '';
        }
    })
    public SavedCartsSummaryNew = ko.pureComputed(() => {
      return this.SavedCarts().length;
    })

    //Headers
    public LocalKey: KnockoutObservable<string> = ko.observable(null);
    public Promo: KnockoutObservable<CartItem> = ko.observable();
    public RxCheck: KnockoutObservable<string> = ko.observable(null);
    public UserLocked: KnockoutObservable<boolean> = ko.observable(false);
    public QuoteRequested: boolean = false;
    public LastActivity: KnockoutObservable<string> = ko.observable(null); 
    public HeaderRequestID: KnockoutObservable<number> = ko.observable(0);
    public IsPromoUser: KnockoutObservable<boolean> = ko.observable(false);

    //Summaries
    private NumOfItems: KnockoutObservable<number> = ko.observable(0);
    private PromoDiscountAmount: KnockoutObservable<number> = ko.observable(0);
    public SubTotal: KnockoutObservable<number> = ko.observable(0);    

    //Cart
    public CartItems: KnockoutObservableArray<CartItem> = ko.observableArray(null);
    private LatestCartObject: KnockoutObservable<ICartData> = ko.observable();

    public TotalPromoSavings: KnockoutObservable<number> = ko.observable(0.00);
    public TotalContractSavings: KnockoutObservable<number> = ko.observable(0.00);
    public TotalSumSavings: KnockoutObservable<number> = ko.observable(0.00);
    public TotalCartSubtotal: KnockoutObservable<number> = ko.observable(0.00);
    
    //Helpers
    public isCartObject(arg: any): arg is ICartData { return true };
    public isPromoResponseModel(arg: any): arg is IPromoResponseModel { return true };
    
    public ParseCartData = (data: ICartData) => {
        
        let self = this;
        let cart: ICartData = { ...data };

        self.Promo(null);

        
        return new Promise((resolve) => {
            if (cart) {                
                // Clear data
                self.CartItems([]);

                if (cart.CartOrderNo) {
                    self.LocalKey(cart.CartOrderNo.toString().trim());
                    localStorage.setItem("CartSessionKey", cart.CartOrderNo.toString().trim());
                }

                self.NumOfItems(cart.NumOfItems);
                self.SubTotal(cart.SubTotal);
                self.RxCheck(cart.RxCheck);
                self.UserLocked(cart.UserLocked);                
                self.IsPromoUser(cart.PromoResponseModel.IsUserEligibleToUsePromo);
                
                self.TotalPromoSavings(cart.TotalPromoSavings);
                self.TotalContractSavings(cart.TotalContractSavings);
                self.TotalSumSavings(cart.TotalSumSavings);
                self.TotalCartSubtotal(cart.TotalCartSubtotal);                                
            }

            if (cart.CartItems) {

                if (cart.DiscountType === "P") {

                    let item: CartItem = new CartItem();
                    item.UoMDesc = "PP";
                    item.Heading = cart.PromoCode;

                    item.CartOrderID = cart.CartOrderNo;
                    item.ListPrice = 0;
                    
                    // Fill other required fields 
                    item.ItemID = "PROMO_" + cart.PromoCode;
                    item.Description = cart.PromoCode + " - " + cart.PercDiscount + "% discount off all items";                    
                    item.PercDiscount = cart.PercDiscount;
                    
                    self.Promo(item);
                }
                if (cart.DiscountType === "N") {
                    
                    let item: CartItem = new CartItem();
                    item.UoMDesc = "NN";
                    item.Heading = cart.PromoCode;

                    item.CartOrderID = cart.CartOrderNo;
                    item.ListPrice = 0;
                    
                    // Fill other required fields 
                    item.ItemID = "PROMO_" + cart.PromoCode;
                    item.Description = cart.PromoCode + " - "  + "discount off select items";                    
                    self.Promo(item);
                }

                let filenameRe = /([\w\d_-]*)\.?[^\\\/]*$/i;
                cart.CartItems.forEach((item: any, index: number) => {
                    
                    if (!(item.ImageUrl === undefined || item.ImageUrl === null)) {
                        let imageUrlExt = item.ImageUrl.split('.').pop().toLowerCase().trim();
                        let imageUrlFile = item.ImageUrl.match(filenameRe)[1];
                        if (imageUrlExt === "jpg") {
                            item.ImageUrl = "/Content/ProductImages/80x60/" + imageUrlFile + "." + imageUrlExt;
                        }
                    }


                    item.ProductUrl = typeof item.Heading != 'undefined' ?
                        item.Heading !== null ? // Append slugified item heading if available, else just use IGRN
                            "/products/details/" + item.ItemGroupRecNo + "/" + Slugify(item.Heading) + "/" :
                            "/products/details/" + item.ItemGroupRecNo + "/" : null;

                    // Check for promo meta data and process accordingly                       
                    if (typeof item.ItemID != 'undefined' && item.VendName === "Promo Codes") {

                        // Reuse these fields to store promocode data.
                        item.UoMDesc = "DD"; // discount type
                        item.Heading = item.ItemID;

                        // Splice out the promo item
                        self.CartItems().splice(index, 1);
                        // Decrement the item count
                        self.NumOfItems(cart.NumOfItems - 1);

                        self.Promo(item);                        
                    }
                    else {
                        // Push in the raw cart data into our observable array
                        self.CartItems.push(item);
                    }
                })
            };

            cart.Messages = "System: Cart items processed.";
            self.LatestCartObject(cart);
            self.LastActivity(cart.LastActivity)

            if (cart.LastActivity === "Requested Quote")
                self.QuoteRequested = true;

            // Reset the notification badge
            $('.cart-icon-panel > .fa-shopping-cart')
                .removeClass("badge-enum");
            $('.cart-icon-panel > .shopping-cart-new')
                .removeClass("badge-enum-new");

            // Set the notification badge value if there are items in cart.
            if (self.NumOfItems() > 0) {
                $('.cart-icon-panel > .fa-shopping-cart')
                    .addClass("badge-enum")
                    .attr('data-content', self.NumOfItems().toString().trim());
                $('.cart-icon-panel > .shopping-cart-new')
                  .addClass("badge-enum-new")
                  .attr('data-content', self.NumOfItems().toString().trim());
            }

            resolve(self);
        })
    };

    // Call this method every time an action changes the headers
    public UpdateRequestID = () => {
        let self = this;
        // Set random number so we can subscribe to HeaderRequestID and be notified when the header changes
        let seed = Math.floor(Math.random() * 1000000000);
        self.HeaderRequestID(seed);
        // Store the latest requestID offline
        localStorage.setItem("CartRequestID", seed.toString());
        return seed;
    }

    
    public GetHeader = () => {
        let self = this;
        let key = localStorage.getItem("CartSessionKey");

        if (!key) {
            // Return self as is
            return new Promise((resolve) => { return resolve(self) });
        }

        let headerAjax = new Promise((resolve, reject) => {
            console.info("Retrieving cart headers...")
            new AjaxPost({
                backdrop: false,
                endpoint: '/ShoppingCart/ValidateKey',

                payload: JSON.stringify({ CartSessionKey: key }),

                cbFunction: function (data: ICartData) {

                    if (data.isCartSessionKeyInvalid == true)
                    {                      
                        console.log("removing cartKey")
                        localStorage.removeItem("CartSessionKey");                        
                    }
                    else
                    {
                        console.log("not removing cartKey")                        
                        self.ParseCartData(data);
                        self.LocalKey(data.CartOrderNo.toString());                                                                    
                    }

                    // Set random number so we can subscribe and be notified when GetHeader() succeeds
                    let requestID = self.UpdateRequestID();
                    console.debug("Cart headers loaded, request id", ko.unwrap(requestID));
                    return resolve(self);
                },
                errFunction: function (err) {
                    return reject(self);
                }
            });

        })

        return headerAjax;
    };    

    public GetSavedCarts = () => {
        console.info("Retrieving saved carts...");
        console.time("GetSavedCarts")
        let self = this;
        return new Promise(() => {
            $.getJSON("/MyAccount/CartsSavedList?" + (new Date).getTime())
                .done((data) => {
                    console.timeEnd("GetSavedCarts")
                    // Empty the array
                    self.SavedCarts([]);

                    if (data !== "Error: Not logged in.") {

                        let array = [],
                            savedCartsPath: string[] = ['/MyAccount/CartsSaved', '/MyAccount/CartsSaved/', '/MyAccount/CartsSaved/Index'];

                        ParseDate(data, array, ["DateStarted"]);

                        array.forEach((cart: ICartData) => {

                            // Map item to temporary variable
                            var parsedItem: any = cart;

                            if (savedCartsPath.indexOf(window.location.pathname) !== -1) {


                                //Check item list for promo item
                                cart.CartItems.forEach((item: ICartRowItem, i) => {
                                    // If match, splice it out of the list and set the NumOfItems tally by -1
                                    if (item.ItemID.toLowerCase().search("promo") != -1) {
                                        // splice at index i, delete 1 element
                                        cart.CartItems.splice(i, 1);
                                        cart.NumOfItems -= 1;
                                    }
                                });
                            }
                            if (parsedItem) {
                                // Format date: split the original item and return the first element as the new value
                                //parsedItem.DateStarted = cart.DateStarted.split('T')[0];
                                // Format currency output
                                parsedItem.SubTotal = '$' + cart.SubTotal.toFixed(2);
                                // Push adjusted item into the observable array
                                self.SavedCarts.push(parsedItem);
                            }

                        });

                        console.info("Saved carts retrieved.");

                    } else {
                        // old code, shouldn't happen since we can check at page render if user is logged in.
                        console.debug("SavedCarts error", data);
                    }

                })
                .then(() => {
                    if (window.location.pathname === "/MyAccount/CartsSaved") {
                        if (self.SavedCarts.length < 1) {
                            $(".preloader").hide();
                        }
                    }
                })
                .catch((err) => { console.error("Error", err) });
        });
    };
}